import React from 'react';
import GridItem from 'components/Grid/GridItem.jsx';
import checkboxImage from 'assets/icons/Checkbox.svg';
import checkedImage from 'assets/icons/checkedicon.svg';
import GridContainer from 'components/Grid/GridContainer.jsx';
import toIndianCurrency from 'utils/ToIndianCurrencyFormat.js';
import { Typography } from '@material-ui/core';

const blueRow = {
  background: '#D9EDF7',
  display: 'flex',
  alignItems: 'center',
  padding: '5px',
  borderRadius: '5px',
  justifyContent: 'space-between',
  marginBottom: '10px',
};

export default function MoreTruckerDeductions({
  classes,
  indentDetails,
  state,
}) {
  const { latestTransactionNumber, hardCodeTransactionNumber, showTds } = state;
  const sendValueTotransporterTdsDeducted = () =>
    latestTransactionNumber < hardCodeTransactionNumber || showTds;
  return (
    <GridItem xs={12} sm={12} md={12}>
      <GridContainer className={classes.customMargin}>
        <GridItem xs={12} sm={12} md={12}>
          <h3
            style={{
              fontSize: '16px',
              color: 'black',
              fontWeight: '400',
              margin: '10px 0px',
            }}
          >
            More Trucker Deductions
          </h3>
          <p style={{ color: 'red', fontSize: '12px' }}>
            (If checkbox is ticked, these values will be shown in Loading Slip)
          </p>
        </GridItem>

        <GridItem className={classes.noPadding} xs={12} sm={12} md={12}>
          <GridContainer spacing={2}>
            <GridItem xs={6} md={4}>
              <div style={blueRow}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {indentDetails?.doc_charges_trucker_showinloadingslip ? (
                    <img
                      src={checkedImage}
                      alt="icon"
                      style={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '16px',
                      }}
                    />
                  ) : (
                    <img
                      src={checkboxImage}
                      alt="icon"
                      style={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '16px',
                      }}
                    />
                  )}

                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    DOC CHARGES
                  </Typography>
                </div>

                <Typography
                  variant="body1"
                  style={{
                    color: 'black',
                  }}
                >
                  {toIndianCurrency(indentDetails?.doc_charges_trucker_amount)}
                </Typography>
              </div>
            </GridItem>
            <GridItem xs={6} md={4}>
              <div style={blueRow}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {indentDetails?.fuel_charges_trucker_showinloadingslip ? (
                    <img
                      src={checkedImage}
                      alt="icon"
                      style={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '16px',
                      }}
                    />
                  ) : (
                    <img
                      src={checkboxImage}
                      alt="icon"
                      style={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '16px',
                      }}
                    />
                  )}

                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    FUEL CHARGES
                  </Typography>
                </div>
                <Typography
                  variant="body1"
                  style={{
                    color: 'black',
                  }}
                >
                  {toIndianCurrency(indentDetails?.fuel_charges_trucker_amount)}
                </Typography>
              </div>
            </GridItem>
            <GridItem xs={6} md={4}>
              <div style={blueRow}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {indentDetails?.maamol_charges_trucker_showinloadingslip ? (
                    <img
                      src={checkedImage}
                      alt="icon"
                      style={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '16px',
                      }}
                    />
                  ) : (
                    <img
                      src={checkboxImage}
                      alt="icon"
                      style={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '16px',
                      }}
                    />
                  )}

                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    MAAMOL CHARGES
                  </Typography>
                </div>
                <Typography
                  variant="body1"
                  style={{
                    color: 'black',
                  }}
                >
                  {toIndianCurrency(
                    indentDetails?.maamol_charges_trucker_amount
                  )}
                </Typography>
              </div>
            </GridItem>

            <GridItem xs={6} md={4}>
              <div style={blueRow}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {indentDetails?.shortage_charges_trucker_showinloadingslip ? (
                    <img
                      src={checkedImage}
                      alt="icon"
                      style={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '16px',
                      }}
                    />
                  ) : (
                    <img
                      src={checkboxImage}
                      alt="icon"
                      style={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '16px',
                      }}
                    />
                  )}

                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    SHORTAGE / DAMAGE
                  </Typography>
                </div>
                <Typography
                  variant="body1"
                  style={{
                    color: 'black',
                  }}
                >
                  {toIndianCurrency(
                    indentDetails?.shortage_charges_trucker_amount
                  )}
                </Typography>
              </div>
            </GridItem>
            <GridItem xs={6} md={4}>
              <div style={blueRow}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {indentDetails?.late_delivery_trucker_showinloadingslip ? (
                    <img
                      src={checkedImage}
                      alt="icon"
                      style={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '16px',
                      }}
                    />
                  ) : (
                    <img
                      src={checkboxImage}
                      alt="icon"
                      style={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '16px',
                      }}
                    />
                  )}

                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    LATE DELIVERY
                  </Typography>
                </div>
                <Typography
                  variant="body1"
                  style={{
                    color: 'black',
                  }}
                >
                  {toIndianCurrency(
                    indentDetails?.late_delivery_trucker_amount
                  )}
                </Typography>
              </div>
            </GridItem>
            {sendValueTotransporterTdsDeducted() && (
              <GridItem xs={6} md={4}>
                <div style={blueRow}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {indentDetails?.tds_trucker_showinloadingslip ? (
                      <img
                        src={checkedImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',
                          marginRight: '5px',
                          width: '16px',
                        }}
                      />
                    ) : (
                      <img
                        src={checkboxImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',
                          marginRight: '5px',
                          width: '16px',
                        }}
                      />
                    )}

                    <Typography
                      variant="body1"
                      style={{
                        color: 'black',
                      }}
                    >
                      TDS
                    </Typography>
                  </div>

                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    {toIndianCurrency(indentDetails?.tds_trucker_amount)}
                  </Typography>
                </div>
              </GridItem>
            )}
            <GridItem xs={6} md={4}>
              <div style={blueRow}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {indentDetails?.early_settlement_trucker_showinloadingslip ? (
                    <img
                      src={checkedImage}
                      alt="icon"
                      style={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '16px',
                      }}
                    />
                  ) : (
                    <img
                      src={checkboxImage}
                      alt="icon"
                      style={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '16px',
                      }}
                    />
                  )}

                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    EARLY SETTLEMENT CHARGES
                  </Typography>
                </div>
                <Typography
                  variant="body1"
                  style={{
                    color: 'black',
                  }}
                >
                  {toIndianCurrency(
                    indentDetails?.early_settlement_trucker_amount
                  )}
                </Typography>
              </div>
            </GridItem>
            <GridItem xs={6} md={4}>
              <div style={blueRow}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {indentDetails?.late_pod_trucker_showinloadingslip ? (
                    <img
                      src={checkedImage}
                      alt="icon"
                      style={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '16px',
                      }}
                    />
                  ) : (
                    <img
                      src={checkboxImage}
                      alt="icon"
                      style={{
                        marginLeft: '10px',
                        width: '16px',
                        marginRight: '5px',
                      }}
                    />
                  )}

                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    LATE POD
                  </Typography>
                </div>
                <Typography
                  variant="body1"
                  style={{
                    color: 'black',
                  }}
                >
                  {toIndianCurrency(indentDetails?.late_pod_trucker_amount)}
                </Typography>
              </div>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </GridItem>
  );
}
